import React, { useEffect, useRef, useState } from "react";
import useProfileDashboard from "../../services/Settings/useProfileDashboard";
import LandingCta from "../../components/LandingPage/LandingCta";
import { Link } from "react-router-dom";
import blueTick from "../../images/LandingPageImage/blueTick.svg";
import usePlans from "../../services/LandingPage/usePlans";
import dropdown from "../../images/LandingPageImage/dropDown.svg";

const PlanPricing = ({ userID }) => {
  const { fetchAlaCartePlans, buyAddOns } = useProfileDashboard();

  const [alaCartePlans, setAlaCartePlans] = useState([]);
  const [selectedPlans, setSelectedPlans] = useState([]);
  const pricingRef = useRef(null);
  const { plans, loading } = usePlans("IN");
  const [showMore, setShowMore] = useState(false);

  useEffect(() => {
    loadAlaCartePlans();
  }, []);

  const loadAlaCartePlans = async () => {
    try {
      const res = await fetchAlaCartePlans({ userid: userID });

      if (res.responseCode === "00") {
        setAlaCartePlans(res.data);
      }
    } catch (err) {
      console.error("Error fetching plans", err);
    }
  };

  const handleCardClick = (plan) => {
    if (selectedPlans.includes(plan.id)) {
      setSelectedPlans(selectedPlans.filter((id) => id !== plan.id));
    } else {
      setSelectedPlans([...selectedPlans, plan.id]);
    }
  };

  const handleCollectiveBuy = async () => {
    if (selectedPlans.length === 0) return;

    try {
      const payload = {
        userid: userID,
        addOns: selectedPlans.join(","),
      };

      const res = await buyAddOns(payload);

      if (res.responseCode === "00") {
        window.location.href = res.data.paymentLink;
      }
    } catch (err) {
      console.error("Buy error", err);
    }
  };

  return (
    <>
  
    <div className="h-full flex flex-col overflow-hidden">
      <div className="flex-1 overflow-y-auto hide-scrollbar min-h-0">
        <section className="py-10 montserrat-font-1" ref={pricingRef}>
          <div className="max-w-6xl mx-auto text-center bg-white rounded-2xl py-16 px-5 md:px-10 montserrat-font-1">
            <h1 className="text-3xl font-semibold mb-8 text-gray-800 max-w-5xl">
              Elevate meaningful <br /> customer conversations.
            </h1>

            <div className="grid md:grid-cols-3 gap-10">
              {plans.map((plan) => (
                <div
                  key={plan.id}
                  className={`rounded-2xl shadow-lg p-8 montserrat-font-1 ${
                    plan.plan_name === "Standard"
                      ? "border-2 border-green-600"
                      : "border"
                  }`}
                >
                  <h3 className="text-xl font-semibold mb-4 text-start">
                    {plan.plan_name}
                  </h3>

                  <div className="text-3xl font-bold text-green-600 mb-2 text-start montserrat-font-1">
                    {plan.currency === "INR" ? "₹" : "$"}
                    {Number(plan.plan_price).toFixed(0)}
                    <span className="text-base text-gray-500 ml-1">
                      {plan.plan_duration}
                    </span>
                  </div>

                  {plan.is_setup_fee_applicable === "Y" && (
                    <div className="border-t border-b border-gray-200 py-3 my-4">
                      <p className="text-sm text-gray-900 montserrat-font-2">
                        + OneTime Setup Fee{" "}
                        {plan.currency === "INR" ? "₹" : "$"}
                        {Number(plan.setup_fee).toFixed(0)}
                      </p>
                    </div>
                  )}

                  <p className="text-gray-600 mb-6 text-start montserrat-font-2">
                    {plan.plan_desc}
                  </p>

                  <Link
                    to={`/buy-plan/${plan.id}`}
                    className="block text-center bg-green-600 hover:bg-green-700 text-white py-3 rounded-xl transition mb-6"
                  >
                    {plan.button_text || "Get Started"} →
                  </Link>

                  <div className="space-y-3 text-left montserrat-font-1">
                    {plan.features
                      ?.filter((f) => f.status === "Y")
                      .slice(0, showMore ? plan.features.length : 5)
                      .map((feature, index) => (
                        <div key={index} className="flex items-start gap-2">
                          <img src={blueTick} className="w-4 mt-1" alt="" />
                          <span className="text-sm text-gray-700 montserrat-font-2">
                            {feature.feature_name}
                          </span>
                        </div>
                      ))}
                  </div>
                </div>
              ))}
            </div>
            {/* Show More */}
            <div className="flex justify-center py-10 montserrat-font-1">
              <button
                onClick={() => setShowMore(!showMore)}
                className="gray-button border border-gray-300 rounded-full px-6 py-2 text-sm flex items-center gap-2 hover:bg-gray-50 transition"
              >
                {showMore ? "View less details" : "View all Feature details"}
                <img src={dropdown} className="w-4 h-4" alt="" />
              </button>
            </div>
          </div>
        </section>

        <div className="mx-6">
          <div className="max-w-6xl mx-auto mb-10 bg-white rounded-2xl py-10 px-10 md:px-15 montserrat-font-1">
            {/* Heading */}
            <h2 className="text-3xl font-bold text-center text-gray-800 p-10">
              Available Ala-Carte Plans
            </h2>

            {/* Plans Grid */}
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 montserrat-font-1">
              {alaCartePlans.map((plan) => (
                <div
                  key={plan.id}
                  onClick={() => handleCardClick(plan)}
                  className={`relative border rounded-2xl p-6 cursor-pointer transition-all duration-300 shadow-sm hover:shadow-lg montserrat-font-1
        ${
          selectedPlans.includes(plan.id)
            ? "border-blue-600 bg-blue-50"
            : "border-gray-200 bg-white hover:border-blue-400"
        }`}
                >
                  {/* Checkbox */}
                  <input
                    type="checkbox"
                    checked={selectedPlans.includes(plan.id)}
                    readOnly
                    className="absolute top-4 right-4 w-4 h-4 accent-blue-600"
                  />

                  {/* Title */}
                  <h4 className="font-semibold text-lg text-gray-800 mb-2">
                    {plan.add_on_module_name || plan.module_name}
                  </h4>

                  {/* Price */}
                  <div className="inline-block border rounded-full bg-blue-50 px-4 py-2 mb-4 w-full montserrat-font-1">
                    <p className="text-2xl font-bold text-green-600">
                      ₹ {Number(plan.module_price).toFixed(0)}
                    </p>
                  </div>

                  {/* Services */}
                  <p className="text-md text-gray-700 font-semibold mb-2">
                    Services Included
                  </p>

                  <div className="border bg-gray-50 rounded-full p-4 py-3 w-full montserrat-font-1">
                    <ul className="space-y-2 text-sm text-gray-700">
                      {plan.services?.map((service) => (
                        <li key={service.id} className="flex items-start gap-2">
                          <span>{service.service_name}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>

            {/* Buy Button */}
            <div className="flex justify-center mt-12 montserrat-font-1">
              <button
                onClick={handleCollectiveBuy}
                disabled={selectedPlans.length === 0}
                className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-8 py-3 rounded-xl shadow-md disabled:opacity-50 transition mb-8"
              >
                Buy Selected Plans →
              </button>
            </div>
          </div>
        </div>

        <LandingCta />
      </div>
    </div>
    </>
  );
};

export default PlanPricing;
